const OPTIONS = [
  { value: 1, label: '24h' },
  { value: 2, label: '7d' },
  { value: 3, label: '30d' },
  { value: 4, label: 'Mês' },
]

export default function PeriodPicker({ value, onChange }) {
  return (
    <div
      className="inline-flex items-center rounded-xl border p-0.5"
      style={{ borderColor: 'var(--dash-border)' }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className="rounded-lg px-2.5 py-1 text-[11px] font-medium transition-colors"
            style={{
              color: active ? 'var(--dash-text)' : 'var(--dash-text-muted)',
              background: active ? 'var(--dash-surface-hover)' : 'transparent',
            }}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
